import { Injectable } from '@angular/core';
import { ApiServiceService } from '../../services/api-service/api-service.service';
import { LoaderFactory } from '../loader/loader.factory';

@Injectable({
  providedIn: 'root'
})
export class EditDocumentOffice365Factory {
  editDocument:any = {}
  constructor(
    private apiService: ApiServiceService,
    private loader: LoaderFactory
  ) { }

  recieveAndProcessDocument(documentSelected:any){
    this.editDocument.documentToEdit = documentSelected;
    this.openDocument()
  }

  openDocument(){
    this.apiService.get('utils/office365', 'login-url')
      .then((data:any)=>{
        this.editDocument.loginUrl = data.loginUrl;
        this.editDocument.idOperation = data.idOperation
        this.editDocument.token = data.token
        this.initAuth()
      },(errorData:any)=>{

      })
  }

  initAuth() {
    const loginWindow: any = window.open(
      this.editDocument.loginUrl,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400'
    );
    const timer = setInterval(async () => {
      if (loginWindow && loginWindow.closed) {
        clearInterval(timer);
        this.getEditUrl();
      }
    }, 1000);
  }


  getEditUrl() {
    this.loader.openLoader('open-office365-document');
    const tokenObject: any = {
      idOperation: this.editDocument.idOperation,
      token: this.editDocument.token
    }
    const documentObjectId = this.editDocument.documentToEdit.documentObjectId ?? this.editDocument.documentToEdit.DocumentObjectId;
    const reportDocumentId = this.editDocument.documentToEdit.reportDocumentId ?? this.editDocument.documentToEdit.ReportDocumentId;
    const expandUrl: string = documentObjectId ? `?documentObjectId=${documentObjectId}` : `?reportDocumentId=${reportDocumentId}`;
    this.apiService.add(`utils/office365/upload/${expandUrl}`, tokenObject)
      .then((data: any) => {
        this.loader.closeLoader('open-office365-document');
        window.open(data.documentEditUrl, '_blank');
      }, (errorData: any) => {
        this.loader.closeError();
      });
  }
}
